import React, { useContext, useState } from 'react';
import { BsSearch } from 'react-icons/bs';

import './SearchBar.css';
import fetchProducts from '../../api/fetchProducts';
import AppContext from '../../context/AppContext';

function SearchBar() {

	const [searchValue, setSearchValue] = useState('');

	const { setProducts, setLoading } = useContext(AppContext);

	const handlerSearch = async (event) => {
		event.preventDefault();
		setLoading(true);
		const products = await fetchProducts(searchValue);
		setSearchValue('');
		setProducts(products);
		setLoading(false);
	};

	return (
		<form className="seach-bar" onSubmit={handlerSearch}>
			<input type="search" 
				value={searchValue}
				placeholder="Buscar produtos" 
				className="search__input"
				onChange={ ( {target} ) => setSearchValue(target.value)}
				required
			/>
			<button type="submit" className="search__button">
				<BsSearch />
			</button>
		</form>
	);
}

export default SearchBar;
